export var FULL_WIDTH_MARGINS = 48;
export var MAX_SPACING = 300;
